import {keys} from 'ts-transformer-keys';

import {Messages} from '~/shared/src/utilities/dataExtraction';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type ChartScaleAxis = 'y' | 'r' | 'x';
export type ChartAxisPosition = 'start' | 'center' | 'end';
export type ChartScaleType = 'category' | 'linear' | 'logarithmic' | 'time';

// CFG:ChartScale
export type ChartScale = {
    data : {
        id : number;
        key : string;
        name : string;

        axis: ChartScaleAxis;
        position: ChartAxisPosition;
        type: ChartScaleType;
        max? : number;
        min? : number;
        suggestedMax? : number;
        suggestedMin? : number;
        stepSize? : number;

    };
    messages? : Messages; // title
};
export const chartScaleDataProps = keys<ChartScale['data']>();
export const chartScaleProps = keys<ChartScale>();
export const requiredChartScaleProps = keys<RequiredOf<ChartScale>>();
